import { Controller } from '@hotwired/stimulus';
import { buyerAlertsMatch } from '../../../../controllers/api/buyerAlerts';

export default class extends Controller {
  static targets = ['container', 'leadsEllipsesContainer', 'leadsCount', 'cardsContainer']

  static values = {
    saleUniqueHash: String,
    salePrice: String,
    zoneCategoryId: String,
    regionNamePretty: String,
    activeZone: Boolean
  }

  openModal() {
    const modal = document.getElementById('ModalBuyerAlertMatch')
    if (modal) {
      modal.classList.remove('hidden')
    }
  }

  closeModal() {
    const modal = document.getElementById('ModalBuyerAlertMatch')
    if (modal) {
      modal.classList.add('hidden')
    }
  }

  connect = async () => {
    const { buyer_alerts, count } = await buyerAlertsMatch(this.saleUniqueHashValue, this.salePriceValue)
    this.checkConditionDisplay(count)
    if(!this.requestedConditionDisplay) return

    const response = await fetch('https://randomuser.me/api/?inc=picture&results=4')
    const users = await response.json()
    this.containerTarget.classList.remove('hidden')

    this.buyerAlerts = buyer_alerts
    this.users = users
    this.count = count

    await buyer_alerts.forEach((_, index) => {
      this.leadsEllipsesContainerTarget.insertAdjacentHTML('beforeEnd', this.profilePictureHTML(users.results[index].picture.thumbnail))
    });
    this.leadsEllipsesContainerTarget.insertAdjacentHTML('beforeEnd', this.ellipseHTML(`+${count - 4}`))
    this.leadsCountTargets.forEach(leadCount => leadCount.innerHTML = count)

    this.populateModalCards()
  }

  populateModalCards() {
    const cardsContainer = document.querySelector('[data-modal-cards-container]')
    if (!cardsContainer || !this.buyerAlerts) return

    this.buyerAlerts.forEach((buyer_alert) => {
      let buyerAlertMatchCard = `
        <div class='bg-white rounded-2xl shadow-ih-1 overflow-hidden'>
          <div class='bg-ih-blue-10 text-center py-4 px-5'>
            <div class='h4 text-ih-indigo'>${buyer_alert.user_first_name} ${buyer_alert.user_last_name_initial}.</div>
          </div>

          <div class='flex flex-col gap-3 text-left p-4'>
            <div class='text-base text-ih-indigo-40'>Budget</div>

            <div class='font-semibold text-base'>${this.numberToCurrency(buyer_alert.min_budget)} - ${this.numberToCurrency(buyer_alert.max_budget)}</div>

            <div class='text-base text-ih-indigo-40'>À la recherche de</div>

            <div>
              ${buyer_alert.apartment ? "<div class='font-semibold text-base'><i class='fa-duotone fa-apartment'></i> Appartement</div>" : ''}
              ${buyer_alert.house ? "<div class='font-semibold text-base'><i class='fa-duotone fa-house'></i> Maison</div>" : ''}
            </div>

            <div class='text-base text-ih-indigo-40'>Surface</div>

            <div class='font-semibold text-base'> > à ${(Math.floor(buyer_alert.min_area))}m2 / ${buyer_alert.min_room_number == 0 || buyer_alert.min_room_number == 1 ? `Studio et +` : `${buyer_alert.min_room_number} pièces et +`}</div>
          </div>
        </div>
      `

      cardsContainer.insertAdjacentHTML('beforeEnd', buyerAlertMatchCard)
    })
  }

  checkConditionDisplay = (count) => {
    const ParisZone1AboveThreeHundred = count > 300 && this.zoneCategoryIdValue == 1 && this.regionNamePrettyValue == 'Région Parisienne'
    const ParisOtherZonesAboveTwoHundred = count > 200 && this.zoneCategoryIdValue != 1 && this.regionNamePrettyValue == 'Région Parisienne'
    const RegionAboveOneHundred = (count > 100 && this.regionNamePrettyValue != 'Région Parisienne')
    this.requestedConditionDisplay = this.activeZoneValue === true && ( ParisZone1AboveThreeHundred || ParisOtherZonesAboveTwoHundred || RegionAboveOneHundred)
  }

  ellipseHTML = (value) => {
    return `
      <div class='w-12 h-12 rounded-full bg-ih-blue flex items-center justify-center mr-2 -ml-3 z-20'>
        <span class='h4 text-white'>${value}</span>
      </div>
    `
  }

  profilePictureHTML = (value) => {
    return `
      <img src='${value}' alt='profile-picture' class='w-12 h-12 rounded-full -ml-3 border-2 border-ih-blue blur-[2px]'>
    `
  }

  numberToCurrency = (number) => {
    return number.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0  });
  }
}
